import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { api } from "@/api/client";
import { leaveFor } from "@/lib/auth";

/** How the logged-in Member can sign in (GET /dashboard/api/sign-in-methods). */
export interface SignInMethods {
  password: boolean;
  connected: { provider: string; email: string | null; linked_at: string }[];
  /** The providers this deployment has set up. */
  available: string[];
}

export const SIGN_IN_METHODS_KEY = ["sign-in-methods"];

export function useSignInMethods() {
  return useQuery({
    queryKey: SIGN_IN_METHODS_KEY,
    queryFn: () => api.get("sign-in-methods").json<SignInMethods>(),
  });
}

/** Starts the provider's flow in link mode; the browser leaves for the
 * provider and comes back to Settings. */
export function useConnectSignInMethod() {
  return useMutation({
    mutationFn: (provider: string) =>
      api.post(`sign-in-methods/${provider}/connect`).json<{ redirect_url: string }>(),
    onSuccess: ({ redirect_url }) => leaveFor(redirect_url),
  });
}

export function useDisconnectSignInMethod() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (provider: string) => api.delete(`sign-in-methods/${provider}`).json<SignInMethods>(),
    onSuccess: (data) => qc.setQueryData(SIGN_IN_METHODS_KEY, data),
  });
}
